import React from 'react';
import { connect } from 'react-redux';

import { Modal, BlockStack, Text } from '@shopify/polaris';

import { cartLayoutDisable } from '../../redux/actions/cartLayouts';

const DisableCartLayoutModal = ({ cartLayoutId, showDisableCartLayoutModal, setShowDisableCartLayoutModal, cartLayout, disableCartLayout }) => {
  const update = () => {
    disableCartLayout(cartLayoutId);
    setShowDisableCartLayoutModal(false);
  }

  return(
    <Modal
      open={showDisableCartLayoutModal}
      onClose={() => setShowDisableCartLayoutModal(false)}
      title="Disable Cart Layout"
      primaryAction={{
        content: 'Disable Cart Layout',
        destructive: true,
        onAction: () => update(),
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: () => setShowDisableCartLayoutModal(false),
        },
      ]}
    >
      <Modal.Section>
        <BlockStack gap="200">
          <Text as="h3" variant="headingMd">{cartLayout?.label}</Text>
          <Text as="p"><strong>Rows</strong>: {cartLayout?.rows}</Text>
          <Text as="p"><strong>Columns</strong>: {cartLayout?.columns}</Text>
        </BlockStack>
      </Modal.Section>
    </Modal>
  )
}

const mapDispatchToProps = (dispatch) => ({
  disableCartLayout: (cartLayoutId) => dispatch(cartLayoutDisable(cartLayoutId)),
});

export default connect(null, mapDispatchToProps)(DisableCartLayoutModal);
